import React, { InputHTMLAttributes } from 'react';
import styles from './GeneralTable.module.css';

type Props = InputHTMLAttributes<HTMLTableDataCellElement>;

function GeneralTableData({ children, ...rest }: Props) {
  return (
    <td {...rest} className={styles.generalTableData}>
      {children}
    </td>
  );
}

export default GeneralTableData;
